import { Outlet, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import useGlobalState from '../../../Template/atoms/variables';
import { notification } from 'antd';
import { useMsal } from '@azure/msal-react';

const KnowledgeOutlet = () => {
  const { instance } = useMsal();
  const { setPendingApiCalls } = useGlobalState();

  const [notificationApi, contextHolder] = notification.useNotification();

  useEffect(() => {
    triggerApiCalls();
  }, []);

  const triggerApiCalls = async () => {
    try {
      setPendingApiCalls((current) => current.concat(['']));
    } catch (err) {
      notificationApi.error({
        message: 'Falha ao carregar hierarquia',
        description: err?.response?.data?.message
          ? `${err?.response?.data?.message} (${err?.response?.status})`
          : err?.message,
        duration: 5,
      });
      console.log(err);
    } finally {
      setPendingApiCalls((current) => current.filter((item) => item !== ''));
    }
  };

  return (
    <>
      {contextHolder}
      <Outlet />
    </>
  );
};

export default KnowledgeOutlet;
